export default __webpack_public_path__ + "static/media/BodyWhite_diffuse-min.c2d70a51.jpg";